import { Grid, Alert, Paper, Typography } from "@mui/material";

import MetricCard from "./MetricCard";
import AnalysisChart from "./AnalysisChart";

function AnalysisResult({ analysis }) {
  return (
    <Paper
      sx={{
        p: 3,
        mt: 4,
      }}
    >
      <Typography variant="h5" mb={3}>
        AI Analysis Result
      </Typography>

      <AnalysisChart analysis={analysis} />

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <MetricCard
            title="Relevance Score"
            value={`${analysis.relevance.score}%`}
            score={analysis.relevance.score}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <MetricCard
            title="Quality Score"
            value={`${analysis.quality.score}%`}
            score={analysis.quality.score}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <MetricCard
            title="Duplicate"
            value={analysis.duplicate.duplicate ? "YES" : "NO"}
            score={analysis.duplicate.duplicate ? 100 : 0}
          />
        </Grid>
      </Grid>

      <Alert
        severity={
          analysis.aiDecision.decision === "AUTO_APPROVE"
            ? "success"
            : analysis.aiDecision.decision === "REVIEW"
              ? "warning"
              : "error"
        }
        sx={{ mt: 3 }}
      >
        <strong>{analysis.aiDecision.decision}</strong>
      </Alert>

      <Paper
        sx={{
          mt: 3,
          p: 3,
          bgcolor: "#fafafa",
          borderLeft: "5px solid #f97316",
        }}
      >
        <Typography variant="h6" gutterBottom>
          AI Reasoning
        </Typography>

        <Typography>{analysis.aiDecision.reasoning}</Typography>
      </Paper>
    </Paper>
  );
}

export default AnalysisResult;
